import Medium from './Medium';
import Large from './Large';
import Buy from './Buy';
import Empty from './Empty';
import Resizable from './Resizable';

export default {
    medium: Medium,
    large: Large,
    buy: Buy,
    empty: Empty,
    resizable: Resizable,
};
